import React from 'react';
import Icon from '../../../components/AppIcon';

const ConfidenceSlider = ({ value, onChange, disabled, basePoints }) => {
  const confidenceLevels = [
    { value: 1, label: 'Low', multiplier: 1.0, color: 'text-muted-foreground' },
    { value: 2, label: 'Medium', multiplier: 1.5, color: 'text-warning' },
    { value: 3, label: 'High', multiplier: 2.0, color: 'text-primary' },
    { value: 4, label: 'Very High', multiplier: 2.5, color: 'text-success' }
  ];

  const currentLevel = confidenceLevels?.find(level => level?.value === value) || confidenceLevels?.[0];
  const potentialPoints = Math.round(basePoints * currentLevel?.multiplier);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <label className="text-sm md:text-base font-medium text-foreground">
          Confidence Level
        </label>
        <div className="flex items-center gap-2">
          <Icon name="TrendingUp" size={16} className={currentLevel?.color} />
          <span className={`text-sm md:text-base font-semibold ${currentLevel?.color}`}>
            {currentLevel?.label}
          </span>
        </div>
      </div>
      <div className="relative pt-2">
        <input
          type="range"
          min="1"
          max="4"
          step="1"
          value={value}
          onChange={(e) => !disabled && onChange(parseInt(e?.target?.value))}
          disabled={disabled}
          className="w-full h-2 bg-muted rounded-lg appearance-none cursor-pointer disabled:cursor-not-allowed"
          style={{
            background: `linear-gradient(to right, var(--color-primary) 0%, var(--color-primary) ${((value - 1) / 3) * 100}%, var(--color-muted) ${((value - 1) / 3) * 100}%, var(--color-muted) 100%)`
          }}
        />
        <div className="flex justify-between mt-2">
          {confidenceLevels?.map((level) => (
            <span
              key={level?.value}
              className={`text-xs ${value === level?.value ? level?.color : 'text-muted-foreground'}`}
            >
              {level?.label}
            </span>
          ))}
        </div>
      </div>
      <div className="flex items-center justify-between p-3 md:p-4 bg-muted/50 rounded-lg">
        <span className="text-sm md:text-base text-muted-foreground">Potential Points:</span>
        <span className="text-lg md:text-xl font-bold text-primary">
          {potentialPoints} pts
        </span>
      </div>
      <div className="flex items-start gap-2 p-3 bg-primary/5 rounded-lg">
        <Icon name="Info" size={16} className="text-primary mt-0.5 flex-shrink-0" />
        <p className="text-xs md:text-sm text-muted-foreground">
          Higher confidence levels multiply your points but reduce them more if incorrect. Choose wisely!
        </p>
      </div>
    </div>
  );
};

export default ConfidenceSlider;